import { getEmailFromLdapResult, type LDAPResult } from '@adornis/authentication/ldap/server/ldap-internals.js';
import type { LDAP_IMPLEMENTATIONS } from './config.js';

interface LDAPUserData {
  firstName: string;
  lastName: string;
  email: string;
}

interface LDAPImplementation {
  getUserData: (email: string, result: LDAPResult) => LDAPUserData;
  getFilter: (email: string) => string;
}

const defaultImplementation: LDAPImplementation = {
  getUserData: (email, result) => {
    const ldapEmail = getEmailFromLdapResult(result) ?? email;
    const fullName = result.attributes.find(attr => attr.type === 'name')?.values[0];
    const nameParts = fullName?.trim().split(' ');
    if (nameParts.length === 1) return { email: ldapEmail, firstName: fullName, lastName: '-' };
    const firstName = nameParts.slice(0, -1).join(' ');
    const lastName = nameParts.slice(-1);
    return { email: ldapEmail, firstName, lastName };
  },
  getFilter: email => `(&(objectClass=user)(mail=${email}))`,
};

export const ldapImplementations: Record<(typeof LDAP_IMPLEMENTATIONS)[number], LDAPImplementation> = {
  'adornis-authentik': defaultImplementation,
  'goetheuni-frankfurt': defaultImplementation,
  'tu-darmstadt': {
    getUserData: (email, result) => {
      const ldapEmail = getEmailFromLdapResult(result) ?? email;
      const firstName = result.attributes.find(attr => attr.type === 'givenName')?.values[0];
      const lastName = result.attributes.find(attr => attr.type === 'sn')?.values[0];
      return { email: ldapEmail, firstName, lastName };
    },
    getFilter: email => `(&(idmUserAccountType=identity)(mail=${email}))`,
  },
};
